/**
 * Pick a subset of properties of an object
 * @see https://1loc.dev/object/pick-a-subset-of-properties-of-an-object/
 * @param obj
 * @param keys
 * @returns
 */
export const pick = <T extends Record<string, unknown>, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> =>
  Object.keys(obj)
    .filter((k) => keys.includes(k as K))
    .reduce((res, k) => Object.assign(res, { [k]: obj[k] }), {} as Pick<T, K>)
